// Redux actions
import * as REDUX_ACTION from "../../../../../../../v1/services/redux/actions";

export const handleMark = (record, action, dispatch, messageApi, user) => {

  let updatedStatus;
  if (action === "active" && (record.status === 1 || record.status === 0)) {
    updatedStatus = 2;
  } else if (action === "active" && record.status === 3) {
    if (!record.activatedAt) {
      updatedStatus = 1;
    } else {
      updatedStatus = 2;
    }
  } else if (
    action === "suspended" &&
    (record.status === 1 || record.status === 2 || record.status === 0)
  ) {
    updatedStatus = 3;
  } else if (
    action === "terminated" &&
    (record.status === 1 || record.status === 2 || record.status === 3)
  ) {
    updatedStatus = 0;
  } else {
    console.error("Invalid action or status");
  }

  if (updatedStatus !== undefined) {
    const updatedItems = { ...record, status: updatedStatus };
    
    delete updatedItems.key;
    delete updatedItems.groupName;
    delete updatedItems.groupColor;
    delete updatedItems.company_name;
    delete updatedItems.loyalty;

    const updatedRecord = {
      uid: record.uid,
      updatedBy: user?.memid,
      items: updatedItems,
    };

    messageApi.open({
      type: "loading",
      content: "Updating Status...",
      duration: 0,
    });

    dispatch(
      REDUX_ACTION.v1_employee.update_employee_request(updatedRecord, user.uroleid, () => {
        messageApi.destroy();
      })
    );
  } else {
    console.error("Invalid action or status");
  }
};
